import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgHomepageSecureSpending = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 19"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M18.742 1.44C11.255-1.168 4.101.353 1.384 1.44c-2.507 7.138-1.044 13.705 0 16.096 7.432 2.651 14.619 1.105 17.358 0 2.278-6.646.95-13.5 0-16.096"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M9.997 15.544c-.674 0-.935-.112-1.372-.3-1.568-.674-4.2-2.316-4.2-5.745v-.886c0-2.06 0-2.83.292-3.242.295-.414 1.033-.662 3.004-1.328l.326-.109c.941-.317 1.412-.474 1.947-.474s1.005.157 1.947.474l.325.11c1.972.665 2.71.913 3.005 1.327.292.411.292 1.182.292 3.242v.886c0 3.43-2.632 5.071-4.198 5.746-.436.187-.7.3-1.374.3z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M9.997 16.004c-.723 0-1.009-.121-1.476-.324C6.832 14.954 4 13.188 4 9.496v-.953c0-2.216 0-3.045.317-3.487.32-.447 1.113-.713 3.235-1.427l.354-.118C8.917 3.17 9.425 3 10 3s1.082.17 2.094.511l.354.118c2.122.714 2.915.983 3.235 1.427C16 5.498 16 6.33 16 8.543v.953c0 3.69-2.832 5.458-4.518 6.184-.47.203-.753.324-1.479.324zm0-12.097c-.421 0-.883.154-1.796.463l-.354.118c-.889.3-1.587.532-2.066.723-.575.23-.69.338-.714.366-.021.03-.086.175-.12.789-.027.51-.027 1.21-.027 2.174v.953c0 3.172 2.484 4.714 3.967 5.352.421.179.578.248 1.107.248s.689-.066 1.107-.248c1.482-.638 3.967-2.177 3.967-5.352V8.54c0-.968 0-1.666-.027-2.174-.034-.614-.102-.76-.123-.79-.022-.027-.136-.139-.714-.365-.477-.19-1.178-.427-2.067-.723l-.353-.118c-.91-.309-1.372-.463-1.793-.463z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M9.339 11.165a.47.47 0 0 1-.345-.151l-.88-.968a.45.45 0 0 1 .038-.64.467.467 0 0 1 .652.035l.535.587L11.19 7.99a.467.467 0 0 1 .652-.036.45.45 0 0 1 .037.64l-2.196 2.42a.47.47 0 0 1-.344.151"
      />
    </svg>
  );
};
export default SvgHomepageSecureSpending;
